<template>
    <div class="option-card" :class="{ active: saveStock }">
        <div class="option-card-header align-items-center" @click="saveStock = !saveStock">
            <AppCheckbox :model-value="saveStock"/>
            <div>
                <div class="option-card-title">{{ $t('labels.save_stock') }}</div>
                <div class="option-card-subtitle">{{ $t('labels.save_stock_description') }}</div>
            </div>
        </div>
        <div class="option-card-body" v-if="saveStock">
            <FormGroup :label="$t('labels.warehouse')" class="option-card-field">
                <Autocomplete
                    url="/management/warehouses"
                    :model-value="warehouse?.uuid"
                    :selected-value="warehouse?.name"
                    :can-be-empty="true"
                    @update:model-value="value => $emit('update:warehouse', value)"
                />
            </FormGroup>
            <FormGroup :label="$t('labels.supplier')" class="option-card-field">
                <Autocomplete
                    url="/management/suppliers"
                    :model-value="supplier?.uuid"
                    :selected-value="supplier?.name"
                    :can-be-empty="true"
                    @update:model-value="value => $emit('update:supplier', value)"
                />
            </FormGroup>
        </div>
    </div>
    <div class="option-card" :class="{ active: savePrice }">
        <div class="option-card-header align-items-center" @click="savePrice = !savePrice">
            <AppCheckbox :model-value="savePrice"/>
            <div>
                <div class="option-card-title">{{ $t('labels.save_price') }}</div>
                <div class="option-card-subtitle">{{ $t('labels.save_price_description') }}</div>
            </div>
        </div>
        <div class="option-card-body" v-if="savePrice">
            <FormGroup :label="$t('labels.price_custom_field')" class="option-card-field">
                <Autocomplete
                    :url="customFieldsUrl"
                    option-value="title"
                    :query-params="{ models: ['product-item'], types: ['number'] }"
                    :model-value="priceCustomField?.uuid"
                    :selected-value="priceCustomField?.title"
                    :can-be-empty="true"
                    @update:model-value="value => $emit('update:priceCustomField', value)"
                />
            </FormGroup>
        </div>
    </div>
    <div class="option-card" :class="{ active: onlyMatched }">
        <div class="option-card-header align-items-center" @click="$emit('update:onlyMatched', !onlyMatched)">
            <AppCheckbox :model-value="onlyMatched"/>
            <div>
                <div class="option-card-title">{{ $t('labels.only_matched') }}</div>
                <div class="option-card-subtitle">{{ $t('labels.only_matched_description') }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import Autocomplete from "../../../../components/new/form/autocomplete/AppAutoComplete.vue";
import AppCheckbox from "../../../../components/new/form/checkbox/AppCheckbox.vue";

export default {
    name: "StockAndPriceStep",
    components: { FormGroup, Autocomplete, AppCheckbox },
    props: {
        warehouse: {
            type: Object,
            default: null
        },
        supplier: {
            type: Object,
            default: null
        },
        priceCustomField: {
            type: Object,
            default: null
        },
        onlyMatched: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:warehouse', 'update:supplier', 'update:priceCustomField', 'update:onlyMatched', 'update:isReadyForNext'],
    data() {
        return {
            saveStock: !!this.warehouse || !!this.supplier,
            savePrice: !!this.priceCustomField
        }
    },
    computed: {
        customFieldsUrl() {
            return `/projects/${this.$route.params.projectUuid}/pim/custom-fields`;
        },
        isReadyForNext() {
            return !!this.warehouse === !!this.supplier;
        }
    },
    watch: {
        isReadyForNext: {
            immediate: true,
            handler(value) {
                this.$emit('update:isReadyForNext', value);
            }
        },
        saveStock(value) {
            if (!value) {
                this.$emit('update:warehouse', null);
                this.$emit('update:supplier', null);
            }
        },
        savePrice(value) {
            if (!value) {
                this.$emit('update:priceCustomField', null);
            }
        }
    }
}
</script>
<style scoped>
.option-card {
    margin-bottom: 1rem;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
}
.option-card.active {
    background: #eff6ff;
    border-color: #2f80ed;
}
.option-card-header {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 1rem;
    cursor: pointer;
}
.option-card-title {
    font-weight: 600;
    color: #3c4553;
}
.option-card-subtitle {
    font-size: 13px;
    color: #7b8492;
}
.option-card-body {
    display: flex;
    gap: 1rem;
    padding: 0 1rem 1rem;
}
.option-card-field {
    flex: 1;
    min-width: 0;
}
</style>
